
const NoPage = () => {
    return (
        <div> 
            No page
        </div>
    );
};

export default NoPage;